// src/components/Layout/AppShell.js
import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "./AppShell.css";
import { useAuth } from "../../context/AuthContext";
import { AnalysisResultProvider } from "../../context/AnalysisResultContext";
import { ModuleSettingsProvider } from "../../context/ModuleSettingsContext";

export default function AppShell() {
  const { user } = useAuth();
  const mustChange = Boolean(user?.mustChangePassword);

  return (
    <ModuleSettingsProvider>
      <AnalysisResultProvider>
        <div className="app-shell">
          {!mustChange && <Header />}

          <div className="main-area">
            {!mustChange && <Sidebar />}

            <div className="content-area">
              <Outlet />
            </div>
          </div>
        </div>
      </AnalysisResultProvider>
    </ModuleSettingsProvider>
  );
}
